import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { enumUtil } from '../../../../utils/Enum';
import NotificationHandler from '../../../../utils/NotificationHandler';
import isNull from '../../../../utils/NullChecking';
import FormValidator from '../../../../utils/FormValidator';
import { GetZipCode, ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import Menu from '@mui/material/Menu'
import format from 'date-fns/format';
import { Calendar } from 'react-date-range';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import States from '../../../../utils/Constants';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import Loader from '../../../shared/Loader/Loader';
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler';
import DatePicker from '../../../General/DatePicker';
import ModalHeader from '../../../Setup/Shared/ModalHeader';
import FormatPhoneNumber from '../../../../utils/FormatPhoneNumber';
import DeleteConfirmatiom from '../../../General/DeleteConfirmation';
import Audit from '../../../General/Audit';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
import ModalFooter from '../../../Setup/Shared/ModalFooter';

const AddNewGuarantor = (props) => {
    let IsEditAllowed = FindFirstChild('Patient', 'Gurantor')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Gurantor')?.IsDeleted

    const { isOpenGuarantor, OnClose, onDeleteFamilyMember } = { ...props }
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR.data.id
    let Family_Modal = {
        ParentID: "",
        Name: "",
        DOB: null,
        MobileNumber: "",
        Address: "",
        City: "",
        State: "",
        ZipCode: "",
        DeathDate: null,
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NameVal: "",
        ZipCodeLengthVal: "",
        ContactNumberLenghtVal: ""
    }
    const API_URL = enumUtil.controller.PATIENT
    const [FamilyMemberID, setFamilyMemberID] = useState()
    const [FamilyValidationModal, setFamilyValidationModal] = useState(ValidationModal)
    const [FamilySaveUpdateModal, setFamilySaveUpdateModal] = useState({})
    const [mainFamilyModal, setmainFamilyModal] = useState(Family_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [is, setIs] = useState(false);
    const [onFamilysave, setOnFamilysave] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);

    useEffect(() => {
        if (!isNull(props.FamilyMemberID) && props.FamilyMemberID != '0') {
            setDel(true)
            setFamilyMemberID(props.FamilyMemberID)
        } else {
            if (!onFamilysave) {
                setFamilyMemberID(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(FamilyMemberID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": FamilyMemberID,
                "TableName": enumUtil.enumAPITableName.PatientFamilyMember
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                if (!isNull(response.MobileNumber)) {
                    response.MobileNumber = FormatPhoneNumber(response.MobileNumber)
                }
                setmainFamilyModal(response)
            }).catch((error) => {
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [FamilyMemberID])
    const handleFamilyChange = (e) => {
        setIs(true)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainFamilyModal };
        let saveModal = { ...FamilySaveUpdateModal }
        if (name === 'MobileNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainFamilyModal(prevState => ({ ...prevState, ...data?.main }));
                    setFamilySaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainFamilyModal(modal)
        for (var property in Family_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setFamilySaveUpdateModal(saveModal)
    }
    const FamilyValidation = async () => {
        let PhoneNumber = ""
        if (!isNull(mainFamilyModal.MobileNumber)) {
            PhoneNumber = mainFamilyModal.MobileNumber.replace(/[()-\s]/g, '');
        }
        let ValidationModal = {
            NameVal: FormValidator(
                mainFamilyModal.Name,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            ZipCodeLengthVal: FormValidator(
                mainFamilyModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
        }
        await setFamilyValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveFamily = async () => {
        await FamilyValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // LocationSaveUpdateModal['PracticeID'] = practiceID;
            // setLocationSaveUpdateModal(LocationSaveUpdateModal)
            if (!isNull(FamilySaveUpdateModal.MobileNumber)) {
                FamilySaveUpdateModal['MobileNumber'] = FamilySaveUpdateModal.MobileNumber.replace(/[()-\s]/g, "");
            }
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientFamilyMember,
                ID: FamilyMemberID + "",
                ParentID: PateintIDR + "",
                data: { ...FamilySaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setFamilyMemberID(response.id)
                        setOnFamilysave(true)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.message, enumUtil.enumtoaster.error)
                })
        }
    }
    const SetFamilyMemberName = () => {
        if (mainFamilyModal.Name != null && mainFamilyModal.Name != "") {
            return (
                <p className="heading">{mainFamilyModal.Name}</p>
            )
        } else {
            return (
                <p className="heading">Add New Family Members</p>
            )
        }
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainFamilyModal };
        let saveModal = { ...FamilySaveUpdateModal }
        modal[type] = FormatedDate
        setmainFamilyModal(modal)
        for (var property in Family_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setFamilySaveUpdateModal(saveModal)
    }
    const handleDropDownChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainFamilyModal };
        modal[name] = value
        setmainFamilyModal(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainFamilyModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            FamilySaveUpdateModal[name] = selectedData.value;
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            FamilySaveUpdateModal[name] = selectedData.value;
        } else {
            modal[name] = ''
            FamilySaveUpdateModal[name] = ''
        }
        setmainFamilyModal(modal)

        return selectedData
    }

    const handleDeleteModal = () => { setisOpenAlert(true) }
    const onCloseDelete = () => {
        setisOpenAlert(false)
        console.log("setisOpenGuarantor")

    }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    let DeletePopup = "";
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.PatientFamilyMember} value={FamilyMemberID} onClose={onDeleteFamilyMember} />
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={FamilyMemberID + ""} TableName={enumUtil.enumAPITableName.PatientFamilyMember} />
    }
    return (
        <>


            <Modal show={isOpenGuarantor} onHide={OnClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-modal-v1 add_new_family_member">
                {DeleteConfirmation}
                {AuditPopup}
                <Modal.Body>
                    <ModalHeader HeaderName={SetFamilyMemberName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} handleDeleteModal={handleDeleteModal} isClosed={onFamilysave ? onDeleteFamilyMember : OnClose} key={2132} Name={'Guarantor'} IsDeleteAllowed={IsDeleteAllowed} />
                    {isLoading ? <Loader /> : null}
                    <div className="row gy-1">
                        <div className="col-md-6">
                            <div className={FamilyValidationModal.NameVal ? 'form-group input error' : 'input form-group'}>
                                {/* <div className='input form-group'> */}
                                <label>Name<span className='req'>*</span></label>
                                <input
                                    type="text"
                                    className='form-control'
                                    name='Name'
                                    id='Name'
                                    autoComplete='off'
                                    maxLength={55}
                                    value={mainFamilyModal.Name}
                                    onChange={handleFamilyChange}
                                />
                                {FamilyValidationModal.NameVal}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <DatePicker
                                label='DOB'
                                value={mainFamilyModal.DOB}
                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                            />
                        </div>
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label>Cell #</label>
                                <div className={FamilyValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                    <input
                                        type="text"
                                        className='form-control'
                                        name='MobileNumber'
                                        id='MobileNumber'
                                        autoComplete='off'
                                        placeholder="(555) 555-5555"
                                        onKeyPress={handleNumericCheck}
                                        value={mainFamilyModal.MobileNumber}
                                        onChange={handleFamilyChange}
                                    />
                                    {FamilyValidationModal.ContactNumberLenghtVal}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label>City</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    name='City'
                                    id='City'
                                    autoComplete='off'
                                    maxLength={35}
                                    value={mainFamilyModal.City}
                                    onChange={handleFamilyChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label>Address</label>
                                <input
                                    type="text"
                                    className='form-control address_input'
                                    name='Address'
                                    id='Address'
                                    autoComplete='off'
                                    maxLength={55}
                                    value={mainFamilyModal.Address}
                                    onChange={handleFamilyChange}
                                />
                            </div>
                        </div>
                        {/* <div className="col-md-6">
                            <div className='input form-group'>
                                <label>Address</label>
                                <input
                                    type="text"
                                    className='form-control address_input'
                                    name='Address'
                                    id='Address'
                                    autoComplete='off'
                                    maxLength={55}
                                    value={mainFamilyModal.Address}
                                    onChange={handleFamilyChange}
                                />
                            </div>
                        </div> */}
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label>State</label>
                                <SuperSearchList
                                    type="client"
                                    id='State'
                                    name='State'
                                    searchValue={mainFamilyModal.State}
                                    data={States}
                                    onChange={handleDropDownChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                                {/* <input
                                    type="text"
                                    className='form-control'
                                    name='State'
                                    id='State'
                                    maxLength={2}
                                    value={mainFamilyModal.State}
                                    onChange={handleFamilyChange}
                                /> */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <DatePicker
                                label='Date Of Death'
                                value={mainFamilyModal.DeathDate}
                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DeathDate')}
                            />
                        </div>
                        <div className='col-md-6'>
                            <div className={FamilyValidationModal.ZipCodeLengthVal ? 'form-group input error' : 'input form-group'}>
                                {/* <div className='input form-group'> */}
                                <label>ZIP</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    name='ZipCode'
                                    id='ZipCode'
                                    autoComplete='off'
                                    maxLength={9}
                                    onKeyPress={handleNumericCheck}
                                    value={mainFamilyModal.ZipCode}
                                    onChange={handleFamilyChange}
                                />
                                {FamilyValidationModal.ZipCodeLengthVal}
                            </div>
                        </div>
                        {/* <div className='input calender'>
                            <label>Date Of Death</label>
                            <div className='calender-icon'>
                                <input 
                                    readOnly
                                    value={mainFamilyModal.DeathDate}
                                    className='form-control'
                                    onClick={(event) => openCalendarMenu(event, 'DeathDate')}
                                />
                                <i class="bi bi-calendar-fill input-icon"></i>
                            </div>
                            <Menu
                            className='calender-menu'
                            anchorEl={dateOfDeath}
                            open={openDateOfDeath}
                            onClose={closeCalendarMenu}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            >
                                <Calendar
                                        onChange={date => handleCalendarChange(date,'DeathDate')}
                                    />
                            </Menu>
                        </div> */}
                        <div className="col-md-12">
                            <div className='input form-group'>
                                <label>Notes</label>
                                <input
                                    type='text'
                                    className='input form-control'
                                    name='Notes'
                                    id='Notes'
                                    autoComplete='off'
                                    value={mainFamilyModal.Notes}
                                    onChange={handleFamilyChange}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                {/* <div className='btns-group text-end px-3 modal_footer pt-2 br-top-1 br-clr'>
                    <button className='btn btn-gray' onClick={OnClose}>Cancel</button>
                    <button className={IsEditAllowed ? 'btn btn-orange' : 'btn btn-orange disabled'} onClick={handleSaveFamily}>Save</button>
                </div> */}

                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={OnClose}>Cancel</button>
                    <button className={IsEditAllowed ? 'btn btn-validate  px-10 h-100' : 'btn btn-validate  px-10 h-100 disabled'} onClick={handleSaveFamily}>
                        Save
                    </button>
                </div> */}
                <ModalFooter isSaved={OnClose} handleSave={handleSaveFamily} key={214} Name={'addnewguranrator'} UpdatedDate={mainFamilyModal.UpdatedDate} UpdatedBy={mainFamilyModal.UpdatedBy} ID={FamilyMemberID} IsEditAllowed={IsEditAllowed} />

            </Modal>
        </>
    )
}

export default AddNewGuarantor